import React from "react";
import { Field, Label } from "@radix-ui/react-form";

interface FormFieldProps {
  name: string;
  label?: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

export const FormField = ({
  name,
  label = "",
  required = false,
  error,
  children,
  className,
}: FormFieldProps) => {
  return (
    <Field name={name} className={`grid ${className}`}>
      {label && (
        <div className="flex items-baseline justify-between">
          <Label className="text-[15px] font-medium leading-[35px] text-theme-text">
            {label}
            {required && <span className="ml-2 text-red-500">*</span>}
          </Label>
        </div>
      )}
      {error && React.isValidElement(children)
        ? React.cloneElement(children as React.ReactElement<{ error?: string }>, { error })
        : children}
      {/* Only show standalone error label when the child doesn't render its own error message */}
      {error && !React.isValidElement(children) && (
        <Label className="h-4 text-[13px] text-red-500 opacity-80">{error}</Label>
      )}
    </Field>
  );
};
